import { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function BaseIcon(props: IconProps) {
  const { width = 18, height = 18, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    />
  );
}

export function IconPlus(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconUser(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="12" cy="8.2" r="3.2" stroke="currentColor" strokeWidth="2" />
      <path
        d="M5.5 18.5C6.8 15.7 9.2 14.2 12 14.2C14.8 14.2 17.2 15.7 18.5 18.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
}

export function IconUsers(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="9" cy="8.3" r="2.7" stroke="currentColor" strokeWidth="2" />
      <circle cx="15.3" cy="9.2" r="2.2" stroke="currentColor" strokeWidth="2" />
      <path d="M4.6 18.3C5.8 15.9 7.8 14.6 10.2 14.6C12.6 14.6 14.6 15.9 15.8 18.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M13.5 18.1C14.2 16.5 15.4 15.6 16.9 15.6C18 15.6 19 16.1 19.8 17.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconUserPlus(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="9" cy="8.3" r="2.7" stroke="currentColor" strokeWidth="2" />
      <path d="M4.6 18.3C5.8 15.9 7.8 14.6 10.2 14.6C11.7 14.6 13 15.1 14 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M16.5 8.5V14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M13.5 11.5H19.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconBroadcast(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M6.2 9.4L17.8 5.4V14.6L6.2 10.6V9.4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M6.2 10V16.3C6.2 17 6.8 17.6 7.5 17.6H9.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M17.8 7.4C19.1 8.2 19.9 9.5 19.9 11C19.9 12.5 19.1 13.8 17.8 14.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconLock(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <rect x="6.4" y="10.5" width="11.2" height="9.1" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M8.6 10.5V8.4C8.6 6.4 10.2 4.8 12.2 4.8C14.2 4.8 15.8 6.4 15.8 8.4V10.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="14.9" r="1.1" fill="currentColor" />
    </BaseIcon>
  );
}

export function IconPhoto(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <rect x="4.5" y="6" width="15" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
      <circle cx="9" cy="10" r="1.5" fill="currentColor" />
      <path d="M6.5 17L11 12.5L13.8 15.3L15.5 13.6L17.5 15.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </BaseIcon>
  );
}

export function IconFile(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M7 4.5H14L18 8.5V19.5H7V4.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M14 4.8V9H18" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9.5 13H15.5M9.5 16H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconDownload(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M12 4.5V14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 11L12 15L16 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 19H18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconMic(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <rect x="9" y="4" width="6" height="10" rx="3" stroke="currentColor" strokeWidth="2" />
      <path d="M6.5 10.5C6.5 13.5 8.5 15.5 12 15.5C15.5 15.5 17.5 13.5 17.5 10.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 15.5V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M9.5 20H14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconVoiceWave(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M4.8 10.5V13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8.4 8.8V15.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 6.8V17.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M15.6 8.8V15.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M19.2 10.5V13.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="2" />
      <path d="M16 16L20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconRefresh(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19 12A7 7 0 1 1 17.2 7.2M19 5V12H12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}

export function IconBack(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M15 5L8 12L15 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </BaseIcon>
  );
}

export function IconSend(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M4 12L20 4L14 20L11 13L4 12Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </BaseIcon>
  );
}

export function IconReply(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M9 7L4 12L9 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 12H14.5C17.5 12 20 14.5 20 17.5V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconForward(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M15 7L20 12L15 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 12H9.5C6.5 12 4 14.5 4 17.5V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconEdit(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 20L8.6 18.8L19 8.4L15.6 5L5.2 15.4L4 20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M14 6.6L17.4 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconTrash(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M5 7H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M8 7V5.5C8 4.7 8.7 4 9.5 4H14.5C15.3 4 16 4.7 16 5.5V7M7 7L8 19C8.1 19.6 8.6 20 9.2 20H14.8C15.4 20 15.9 19.6 16 19L17 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}

export function IconLogout(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M9 4H6.5C5.7 4 5 4.7 5 5.5V18.5C5 19.3 5.7 20 6.5 20H9" stroke="currentColor" strokeWidth="2" />
      <path d="M13 8L17 12L13 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}

export function IconClose(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </BaseIcon>
  );
}
